import dayjs, { type Dayjs } from '@atlas/tool/box/date/dayjs';

export default function flattenObject(obj: TInput, parentKey = '', result: TInput = {}): TInput {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const newKey = parentKey ? `${parentKey}.${key}` : key;
            if (obj[key] instanceof dayjs) {
                result[newKey] = (obj[key] as Dayjs).valueOf();
            } else if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                flattenObject(obj[key] as TInput, newKey, result);
            } else {
                result[newKey] = obj[key];
            }
        }
    }
    return result;
}

type TInput = Record<string, unknown>;

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('flattenObject', async () => {
        it('flattens object', () => {
            expect(
                flattenObject({
                    field: {
                        nestedField: 'value',
                    },
                }),
            ).toStrictEqual({ 'field.nestedField': 'value' });
        });
    });
}

// #endregion
